import { Box, BoxProps } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import * as React from 'react';

import { PostingExperience, usePostingExperience } from '../PostingExperience';
import { FeedCTA } from './FeedCTA';

export const CreatePostButton: React.FC<
  {
    group?: { _id: string; name: string };
    showFixedGroupName?: boolean;
    organization?: { _id: string; name: string };
  } & BoxProps
> = ({ group, showFixedGroupName, organization, ...boxProps }) => {
  const router = useRouter();

  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  const postingExperience = usePostingExperience({
    modal: {
      isOpen: modalIsOpen,
      onClose: () => setModalIsOpen(false),
      onOpen: () => setModalIsOpen(true),
    },
  });

  React.useEffect(() => {
    if (router.isReady) {
      if (router.query.postModalOpen) {
        const { postModalOpen, ...rest } = router.query;
        router.replace({
          pathname: router.pathname,
          query: rest,
        });
        setModalIsOpen(true);
      }
    }
  }, [router]);

  return (
    <Box {...boxProps}>
      <PostingExperience
        {...postingExperience}
        options={{
          group: group,
          showFixedGroupName: showFixedGroupName,
          organization: organization,
        }}
      />

      <FeedCTA
        onClickPost={() => {
          postingExperience.createPost();
        }}
        onClickArticle={() => {
          postingExperience.createArticle();
        }}
        onClickPoll={() => {
          postingExperience.createPoll();
        }}
        onClickQuestion={() => {
          postingExperience.createQuestion();
        }}
      />
    </Box>
  );
};
